import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import PrivacyContent from '../components/PrivacyContent';
import SiteSections from '../components/SiteSections';

export default function Privacy() {
  useEffect(() => {
    document.title = 'Privacy Policy · PBB';
  }, []);

  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="privacy-page">
      <Link
        to={-1}
        onClick={(e) => { e.preventDefault(); window.history.back(); }}
        className="inline-flex items-center gap-1 text-xs text-green-400 hover:text-green-300"
        data-testid="privacy-back-link"
      >
        <ArrowLeft size={14} /> Back
      </Link>

      <header className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full bg-green-600/15 border border-green-600/40 flex items-center justify-center">
          <Shield className="text-green-400" size={20} />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Privacy Policy</h1>
          <p className="text-gray-400 text-sm">Promote Black Business</p>
        </div>
      </header>

      <div className="pbb-card p-6">
        <PrivacyContent />
      </div>
      <SiteSections pageKey="privacy" />
    </div>
  );
}
